import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'

const CommentaryCommonBox = ({ title, children, className = '', isWrapParagraph = true, contentClass }) => {
  return (
    <div className={`${styles.fallWickets} ${className} common-box p-0 mb-3 br-sm overflow-hidden`}>
      <div className={`${styles.head} ${styles.item}`}>
        <p className="text-uppercase text-primary fw-bold mb-0">{title}</p>
      </div>
      <div className={`${styles.content} ${styles.item} ${contentClass || ''}`}>
        {isWrapParagraph ? <p className="mb-0 text-secondary">{children}</p> : children}
      </div>
    </div>
  )
}

CommentaryCommonBox.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isWrapParagraph: PropTypes.bool,
  contentClass: PropTypes.string
}

export default CommentaryCommonBox
